export const validateOnlyLetters = (text) => {
  let lettersRegex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1 _]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1 _]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1 _]+$/g;
  if (lettersRegex.test(text) === false) {
    return false;
  } else {
    return true;
  }
};
export const validatePhone = (text) => {
  let lettersRegex = /^[0-9]*$/g;
  if (lettersRegex.test(text) === false) {
    return false;
  } else {
    return true;
  }
};
export const validateEmail = (text) => {
  let emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  if (emailRegex.test(text)) {
    return true;
  } else {
    return false;
  }
};
export const validatePassword = (text) => {
  let strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
  if (strongRegex.test(text)) {
    return true;
  } else {
    return false;
  }
};
export const errorMsgs = {
  required: "Este campo es requerido",
  email: "El formato del correo es inválido",
  lettersOnly: "Este campo solo acepta caracteres alfabéticos",
  numbersOnly: "Este campo solo acepta números",
  phone: "El formato del teléfono es inválido",
  atLeastTwo: "Este campo debe contener 2 o más caracteres",
  earlyDate: "La fecha no puede ser menor a la fecha actual",
  earlyDate3pm:
    "En compras después de las 3:00 PM (hora central) la fecha debe ser mayor a la fecha actual",
  disabledSunday:
    "Los días sábados desde 11:00 AM (hora central) y domingos no recibimos nuevos pedidos.",
  morningNotAllowed:
    'Después de las 10:00 AM (hora central) no podemos hacer entregas en el mismo día por la mañana. Por favor selecciona "Entregar por la tarde".',
  password:
    "Mínimo 8 caracteres, una letra en mayúscula, una letra minúscula, un número y un caracter especial.",
  passwordFormat:
    "La contaseña debe contener al menos 8 caracteres, se deben incluir al menos una letra mayúscula, una letra minúscula, un caracter especial, un número.",
  holidaysDeliveryNotAllowed:
    "La fecha seleccionada no está disponible para entregas. Seleccione una fecha diferente al 24,25,26,27,31 de diciembre y 1,2,3 de enero debido a fin de año.",
};
export const validateRequired = (text) => {
  let strongRegex = /^(?![\s\S])/;
  if (!strongRegex.test(text)) {
    return true;
  } else {
    return false;
  }
};
